import SubcontractorPurchaseInvoicesList from "./SubcontractorPurchaseInvoicesList";

export default {
  name: "subcontractorPurchaseInvoices",
  list: SubcontractorPurchaseInvoicesList,
};
